import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "_flexbtwn _ai-c" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      ($props.previousUpdateUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: $props.previousUpdateUrl,
            class: "gfu-link gfu-link--accent",
            onClick: _cache[0] || (_cache[0] = $event => ($options.trackClick('previous'))),
            "data-qa": "project-update-nav:previous"
          }, [
            _createVNode(_component_base_icon, { name: "chevron-left" }),
            _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectUpdates.PreviousUpdateLink), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_2))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", null, [
      ($props.nextUpdateUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: $props.nextUpdateUrl,
            class: "gfu-link gfu-link--accent",
            onClick: _cache[1] || (_cache[1] = $event => ($options.trackClick('next'))),
            "data-qa": "project-update-nav:next"
          }, [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectUpdates.NextUpdateLink) + " ", 1 /* TEXT */),
            _createVNode(_component_base_icon, { name: "chevron-right" })
          ], 8 /* PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}